import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsSettings } from "../../../../features/settings/integrations/integrations-settings";

export const Route = createFileRoute("/w/$slug/settings/integrations")({
  component: IntegrationsSettings,
});
